function adjustFontSize() {
  // 获取屏幕宽度
  const screenWidth = window.innerWidth || document.documentElement.clientWidth;

  // 根据屏幕宽度设置根元素的字体大小
  // 假设我们想要每 100px 屏幕宽度对应 1rem
  const baseFontSize = 16; // 默认的字体大小
  const customFontSize = (screenWidth / 1920) * baseFontSize;

  // 设置 html 的字体大小
  document.documentElement.style.fontSize = `${customFontSize}px`;
}

// 初始化
adjustFontSize();

// 监听窗口大小改变事件
window.addEventListener('resize', adjustFontSize);